import clsx from 'clsx'
import { motion, useAnimation } from 'framer-motion'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { Typography } from 'components/common/Typography/Typography'
import styles from 'components/strategySection/scheme/Scheme.module.scss'
import { SchemeData } from 'components/strategySection/scheme/SchemeData'

import { Flex } from '../../common/flex/Flex'

export const Scheme = () => {
  const controls = useAnimation()
  const [ref, inView] = useInView({ threshold: 0.1 })

  useEffect(() => {
    if (inView) {
      controls.start(i => ({
        opacity: 1,
        transition: { delay: getDelay(i) },
      }))
    }
  }, [controls, inView])

  const getDelay = (index: number) => {
    switch (index) {
      case 0:
        return 0.5
      case 1:
      case 4:
        return 1
      case 2:
      case 5:
        return 1.5
      case 3:
      case 6:
        return 2
      case 7:
        return 2.5
      default:
        return 0
    }
  }

  return (
    <motion.div className={styles.container} ref={ref} initial={{ opacity: 0 }} animate={controls}>
      {SchemeData.map((item, index) => (
        <motion.div
          key={item.title}
          custom={index}
          initial={{ opacity: 0 }}
          animate={controls}
          className={clsx(styles.circle, styles[`appear${index + 1}`])}
        >
          <Flex justify="center" align="center" direction="column" className='w-full text-center'>
            <p className={styles.title}>
              {item.title}
            </p>
            <Typography tag="p" type="xl-heading" className='italic' color="#282828">
              <div dangerouslySetInnerHTML={{ __html: item.description }} />
            </Typography>
          </Flex>
        </motion.div>
      ))}
    </motion.div>
  )
}
